import anime from 'animejs'

export function startAnimationScroll(blocks = []) {
    let observer = false

    if (blocks && blocks.length) {
        observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio > 0.25) {
                        for (const item of blocks) {
                            if (entry.target.classList.contains(item.className)) {
                                if (item.type === 'title') {
                                    startAnimationTitle(entry.target)
                                } else if (item.type === 'text') {
                                    startAnimationText(entry.target)
                                } else if (item.type === 'textFull') {
                                    startAnimationText(entry.target, { full: true })
                                } else if (item.type === 'lineVertical') {
                                    startAnimationLineVertical(entry.target)
                                } else if (item.type === 'lineGorizont') {
                                    startAnimationLineGorizont(entry.target)
                                }
                            }
                        }

                        observer.unobserve(entry.target)
                    }
                })
            },
            {
                threshold: [0, 0.25, 1]
            }
        )

        for (const item of blocks) {
            const blocksFind = document.querySelectorAll(`.${item.className}`)

            if (blocksFind) {
                for (const blockFind of blocksFind) {
                    observer.observe(blockFind)
                }
            }
        }
    }

    return observer
}

export function startAnimationLineVertical(element, params = {}) {
    if (element) {
        const selector = getSelector(element)

        if (selector) {
            anime({
                targets: selector,
                opacity: [0, 1],
                height: [0, '100%'],
                ease: 'cubicBezier(0.25, 0.1, 0.25, 1)',
                duration: params.duration ? params.duration : 1400,
                delay: params.delay ? params.delay : 1000
            })
        }
    }
}

export function startAnimationLineGorizont(element, params = {}) {
    if (element) {
        const selector = getSelector(element)

        if (selector) {
            anime({
                targets: selector,
                opacity: [0, 1],
                width: [0, '100%'],
                easing: 'easeOutExpo',
                duration: params.duration ? params.duration : 1400,
                delay: params.delay ? params.delay : 1000
            })
        }
    }
}

export function startAnimationTitle(element, params = {}) {
    if (element) {
        const selector = getSelector(element, 'span.letter')

        if (selector) {
            anime({
                targets: selector,
                translateX: [40, 0],
                translateZ: 0,
                opacity: [0, 1],
                easing: 'easeOutExpo',
                duration: params.duration ? params.duration : 1200,
                delay: (el, i) => (params.delay ? params.delay : 500) + (params.delayAdditional ? params.delayAdditional : 30) * i
            })
        }
    }
}

export function startAnimationText(element, params = {}) {
    if (element) {
        const selector = getSelector(element, params.full ? false : '.js-row')

        if (selector) {
            anime({
                targets: selector,
                translateY: [40, 0],
                opacity: [0, 1],
                easing: 'easeOutExpo',
                duration: params.duration ? params.duration : 1400,
                delay: (el, i) => (params.delay ? params.delay : 400) + (params.delayAdditional ? params.delayAdditional : 200) * i
            })
        }
    }
}

function getSelector(element, find) {
    if (find) {
        return element
            ? typeof element === 'object'
                ? element.querySelectorAll(find)
                : document.querySelectorAll(`.${element} ${find}`)
            : false
    } else {
        return element ? (typeof element === 'object' ? element : document.querySelectorAll(`.${element}`)) : false
    }
}
